import Breadcrumbs from "@components/ui-components/breadcrumbs";
import Card from "@components/ui-components/card";
import Charts from "@components/charts";
import DateRangePicker from "@components/fields/date-picker/range-picker";
import Flex from "@components/ui-components/flex";
import { LAST_30_DAYS_DATE } from "@src/utility/constants";
import StatsFormatter from "@components/formatters/stats-formatter";
import useDateHandler from "@hooks/use-date-handler";
import { useTranslation } from "react-i18next";
import useChurnReport from "./use-churn";
import { LoaderOverlay } from "@src/@core/components/spinner";

const ChurnReport = () => {
    const { data, getChurnReport, loading } = useChurnReport();
    const { control, handleDateChange } = useDateHandler({
        onSubmit       : getChurnReport,
        defaultHandling: true,
        defaultValues  : LAST_30_DAYS_DATE
    });
    const { t } = useTranslation();

    return (
        <>
            <Breadcrumbs
                items={[
                    {
                        title : "Churn",
                        active: true
                    }
                ]}
                rightChildren={
                    <Flex gap={2} justify="end">
                        <DateRangePicker
                            control={control}
                            customOnChange={handleDateChange}
                            maxDate={new Date()}
                            id="date"
                            name="date"/>
                    </Flex>
                }/>
            <LoaderOverlay
                active={loading}
                children={
                    <Card
                        headerClass="py-1"
                        header={
                            <div>
                                <h4 className="text-muted">{t("Churn Rate")}</h4>
                            </div>
                        }>
                        <Flex justify="center" align="center">
                            <Flex column>
                                <StatsFormatter
                                    id={"total-churned"}
                                    className="font-large-3 fw-bolder"
                                    num={data.widgets.totalChurned}
                                    prefix="$"/>
                                <p className="text-muted">{t("Churn")}</p>
                            </Flex>
                            <i className="mdi mdi-arrow-right-thick font-medium-3 fs-3 mb-2" />
                            <Flex column>
                                <StatsFormatter
                                    id={"average_churn_rate"}
                                    className="font-large-3 fw-bolder"
                                    num={data.widgets.averageChurnRate}
                                    suffix="%"/>
                                <p className="text-muted">{t("Churn Rate")}</p>
                            </Flex>
                        </Flex>
                        <Charts
                            type="area"
                            series={data.chart.series}
                            categories={data.chart.categories}
                            yAxisTitle="Revenue"/>
                    </Card>
                }/>
        </>
    );
};

export default ChurnReport;